import { Route } from "react-router";
import { QUESTIONNAIRES, QUESTIONNAIRE_EDIT } from "@routes/routes";
import { QuestionnaireEditPage, QuestionnairesPage } from "@routes/lazyPages";

/** Questionnaire list and editor. */
export const questionnaireRoutes = (
  <>
    <Route path={QUESTIONNAIRES} lazy={QuestionnairesPage} />
    <Route path={QUESTIONNAIRE_EDIT} lazy={QuestionnaireEditPage} />
  </>
);
